import site from "./site.json";

export function absoluteUrl(path = "/") {
  if (!path || path === "/") return `${site.siteUrl}/`;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${site.siteUrl}${normalized}`;
}

export function getService(slug) {
  return site.services.find((service) => service.slug === slug);
}

export function heroSrcSet(format) {
  return site.hero.widths
    .map((width) => `/hero/hero-${width}.${format} ${width}w`)
    .join(", ");
}

export default site;
